export default "__VITE_ASSET__BwQHlzm9__"